import { defineMessages } from "react-intl";
const messages = defineMessages({
    usersTitle: {
        id: "app.Users.UsersTitle.text",
        defaultMessage: "Your Users",
    },
    usersUsersTitle: {
        id: "app.Users.UsersTabs.Users.text",
        defaultMessage: "Users",
    },
    usersUserRequestsTitle: {
        id: "app.Users.UsersTabs.UserRequests.text",
        defaultMessage: "User Requests",
    },
    usersSearch: {
        id: "app.Users.UsersTabs.searchPlaceholder.text",
        defaultMessage: "Search for a user",
    },
});
export default messages;
